import React from 'react';

const ProcessingStep = ({ loading }) => (
  <div className="min-h-screen bg-gradient-to-br from-emerald-50 to-blue-50 dark:from-gray-900 dark:to-gray-800 py-8">
    <div className="max-w-4xl mx-auto px-4">
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl p-8">
        {loading ? (
          // Skeleton loader for results page
          <div className="space-y-6">
            {/* Header Skeleton */}
            <div className="text-center mb-8">
              <div className="h-8 bg-gray-200 dark:bg-gray-700 rounded-lg w-2/3 mx-auto mb-4 animate-pulse" />
              <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded-lg w-1/2 mx-auto animate-pulse" />
            </div>

            {/* Score Card Skeleton */}
            <div className="bg-gradient-to-r from-emerald-50 to-blue-50 dark:from-gray-700 dark:to-gray-600 rounded-xl p-6 mb-6">
              <div className="h-6 bg-gray-200 dark:bg-gray-600 rounded w-32 mb-4 animate-pulse" />
              <div className="h-16 bg-gray-200 dark:bg-gray-600 rounded-lg w-24 mx-auto mb-4 animate-pulse" />
              <div className="h-4 bg-gray-200 dark:bg-gray-600 rounded w-40 mx-auto animate-pulse" />
            </div>

            {/* Chart/Graph Skeleton */}
            <div className="bg-gray-50 dark:bg-gray-700/50 rounded-xl p-6 mb-6">
              <div className="h-5 bg-gray-200 dark:bg-gray-600 rounded w-48 mb-4 animate-pulse" />
              <div className="h-64 bg-gray-200 dark:bg-gray-600 rounded-lg animate-pulse" />
            </div>

            {/* Category Scores Skeleton */}
            <div className="space-y-4">
              <div className="h-5 bg-gray-200 dark:bg-gray-600 rounded w-40 mb-4 animate-pulse" />
              {[1, 2, 3, 4, 5, 6, 7].map((i) => (
                <div key={i} className="flex items-center gap-4">
                  <div className="h-4 bg-gray-200 dark:bg-gray-600 rounded w-32 animate-pulse" />
                  <div className="flex-1 h-3 bg-gray-200 dark:bg-gray-600 rounded-full animate-pulse" />
                  <div className="h-4 bg-gray-200 dark:bg-gray-600 rounded w-12 animate-pulse" />
                </div>
              ))}
            </div>

            {/* Recommendations Skeleton */}
            <div className="mt-8">
              <div className="h-5 bg-gray-200 dark:bg-gray-600 rounded w-48 mb-4 animate-pulse" />
              <div className="space-y-3">
                {[1, 2, 3].map((i) => (
                  <div key={i} className="bg-gray-50 dark:bg-gray-700/50 rounded-lg p-4 animate-pulse">
                    <div className="h-4 bg-gray-200 dark:bg-gray-600 rounded w-3/4 mb-2" />
                    <div className="h-3 bg-gray-200 dark:bg-gray-600 rounded w-full mb-1" />
                    <div className="h-3 bg-gray-200 dark:bg-gray-600 rounded w-5/6" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        ) : (
          <div className="text-center">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
              Assessment Completed!
            </h2>
            <p className="text-gray-600 dark:text-gray-400 mb-8">Processing your results...</p>
          </div>
        )}
      </div>
    </div>
  </div>
);

export default ProcessingStep;


